import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { MrModalManager } from '@hixme/modal'

// hixme-ui
import AppLayout from 'components/AppLayout'

// project
import SideNavContainer from 'containers/SideNavContainer'
import { NotificationManager } from 'modules/notification-manager/components'
import { JodalContainer } from 'modules/modal/containers'
import { LoggedInAsContainer, PausedBanner } from 'store/modules/user-session/containers'
import HeaderContainer from 'containers/HeaderContainer'

// modals
import { modals } from 'modal-constants'
import TopBannerAlert from '../../components/TopBannerAlert/TopBannerAlert'
import useFeatureFlags from '../../hooks/useFeatureFlags'
import { datadog } from 'helpers/datadog'
import { useDemoLoginEvent } from 'modules/demo-monitoring/useDemoLoginEvent'

const EnrollmeLayout = ({ person, username, children, clientPublicKey, companyName }) => {
  const { flags, methods } = useFeatureFlags()
  useDemoLoginEvent(clientPublicKey, companyName)

  if (person) {
    // Identify the user with LaunchDarkly when the enrollme application is loaded
    methods.identify({
      key: `${person.Id}`,
      email: person.EmailAddress,
      companyId: person.ClientPublicKey,
    })

    // identify the user for datadog
    datadog.setUser({
      id: person.Id,
      name: person.FullName,
      email: person.EmailAddress,
      companyId: person.ClientPublicKey,
      role: person.UserRole,
    })
  }

  const SideNavUser = () => <SideNavContainer userName={username} />

  useEffect(() => {
    if (!flags['customer-service.fe.zendesk-widget-enabled']) return

    const showWidget = () => {
      try {
        window.zE('webWidget', 'show')
      } catch (e) {
        console.error('Error loading Zendesk widget', e)
      }
    }

    // Show immediately if Zendesk has already loaded, otherwise wait for it
    if (window.zE) {
      showWidget()
    } else {
      window.addEventListener('zendeskReady', showWidget, { once: true })
      return () => window.removeEventListener('zendeskReady', showWidget)
    }
  }, [])

  return (
    <div className="h-full">
      <TopBannerAlert />
      <NotificationManager />
      <MrModalManager appElementId="app-layout-node" modals={modals} />
      <JodalContainer />
      <div id="app-layout-node" className="h-full">
        <AppLayout HeaderComponent={HeaderContainer} SidebarComponent={SideNavUser}>
          <PausedBanner />
          <LoggedInAsContainer />
          <div>{children}</div>
        </AppLayout>
      </div>
    </div>
  )
}

EnrollmeLayout.propTypes = {
  children: PropTypes.element.isRequired,
  username: PropTypes.string,
  person: PropTypes.object,
  clientPublicKey: PropTypes.string,
  companyName: PropTypes.string,
}

EnrollmeLayout.defaultProps = {
  username: '',
  person: undefined,
  clientPublicKey: undefined,
  companyName: undefined,
}

export default EnrollmeLayout
